import { GET_OWNER_SERVICES, BLOCK_SERVICE_DATES, UNBLOCK_DATE } from '../actions/types';

const initialState = {
    accommodations: [],
    tours: [],
    blockedDates: [],
    bookResponse: '',
    serverResponse: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_OWNER_SERVICES:
            return {
                ...state,
                success: action.payload.success,
                accommodations: action.payload.accommodations,
                tours: action.payload.tours,
                blockedDates: action.payload.blockedDates,
                bookResponse: ''
            };
        case BLOCK_SERVICE_DATES:
            return {
                ...state,
                bookSuccess: action.payload.success,
                bookResponse: action.payload.message
            };
        case UNBLOCK_DATE:
            return {
                ...state,
                serverResponse: action.payload.message
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ownersReducer.js